'use client'

import Link from 'next/link'
import { getDivingPoolsByRegion } from '@/data/divingPools'
import { useTheme } from '@/contexts/ThemeContext'

export default function IncheonPoolsPage() {
  const { theme } = useTheme()
  const pools = getDivingPoolsByRegion('인천')

  return (
    <div className={`min-h-screen bg-gradient-to-b py-8 px-4 ${theme === 'light' ? 'from-blue-50 to-white' : 'from-gray-900 to-gray-800'}`}>
      <div className="max-w-6xl mx-auto">
        <h1 className={`text-3xl xxs:text-base font-bold mb-4 xxs:mb-2 ${theme === 'light' ? 'text-gray-900' : 'text-white'}`}>인천 다이빙풀</h1>
        <p className={`mb-8 xxs:mb-4 text-sm xxs:text-xs ${theme === 'light' ? 'text-gray-600' : 'text-gray-400'}`}>
          인천 지역의 프리다이빙 풀장 정보입니다. 총 <span className="font-semibold">{pools.length}개</span>의 풀장이 있습니다.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 xxs:gap-3">
          {pools.map((pool) => (
            <Link
              key={pool.id}
              href={`/pools/${pool.id}`}
              className={`p-5 xxs:p-3 rounded-lg shadow-md hover:shadow-xl transition-all ${theme === 'light' ? 'bg-white' : 'bg-gray-800'}`}
            >
              <h3 className={`text-xl xxs:text-sm font-bold mb-3 xxs:mb-2 ${theme === 'light' ? 'text-gray-900' : 'text-white'}`}>{pool.name}</h3>
              <div className={`space-y-2 xxs:space-y-1 text-sm xxs:text-[11px] ${theme === 'light' ? 'text-gray-600' : 'text-gray-400'}`}>
                <p>📍 주소: {pool.address}</p>
                <p>🏊 수심: {pool.depth}</p>
                <p>⭐ 난이도: {pool.level === 'beginner' ? '초급' : pool.level === 'intermediate' ? '중급' : '상급'}</p>
              </div>
              {pool.features && (
                <div className="mt-4 xxs:mt-2 flex flex-wrap gap-2 xxs:gap-1">
                  {pool.features.map((feature, idx) => (
                    <span key={idx} className={`px-3 xxs:px-2 py-1.5 xxs:py-1 text-sm xxs:text-xs rounded-full ${theme === 'light' ? 'bg-blue-100 text-blue-800' : 'bg-blue-900 text-blue-200'}`}>
                      {feature}
                    </span>
                  ))}
                </div>
              )}
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}
